module.exports = __webpack_public_path__ + "static/media/analyse_cv.ff47a086.jpg";